<template>
  <v-card rounded="lg" class="transparent">
    <v-breadcrumbs :items="items" class="px-0">
      <template v-slot:divider>
        <v-icon>ri-arrow-right-s-line</v-icon>
      </template>
    </v-breadcrumbs>
    <v-card-title class="text-black pt-0 px-0 fs-20 font-weight-bold">Need Approval Detail</v-card-title>

    <v-card-text class="px-0">
      <div class="content">
        <div class="table mb-3 col-md-8">
          <div class="row">
            <div class="col-sm-12">
              <v-btn color="primary" class="white--text ma-1" @click="dialog=true">
                <v-icon class="mr-2">ri-checkbox-circle-line</v-icon> Approve Disbursement
              </v-btn>
            </div>
          </div>

          <v-card class="mt-2" elevation="1">            
            <v-card-actions class="grey lighten-3">
              <v-list-item class="grow pr-0 pl-0">                
                <v-list-item-content>
                  <v-list-item-title>AMOUNT</v-list-item-title>
                  <p class="text-black font-weight-medium fs-18">
                    Rp {{ formatPrice(dataDetail.amount) }}
                  </p>
                </v-list-item-content>

                <v-row
                  align="center"
                  justify="end"
                >
                  <v-chip
                    v-if="dataDetail.status === 'wait validation'"
                    color="#FF6F00"
                    outlined
                    class="text-capitalize"
                  >
                    {{ dataDetail.status }}
                  </v-chip>
                  <v-chip
                    v-else-if="dataDetail.status === 'wait approval'"
                    color="#F0AB0B"
                    outlined
                    class="text-capitalize"
                  >
                    {{ dataDetail.status }}
                  </v-chip>
                  <v-chip
                    v-else-if="dataDetail.status === 'failed'"
                    color="#E53935"
                    outlined
                    class="text-capitalize"
                  >
                    {{ dataDetail.status }}
                  </v-chip>
                  <v-chip
                    v-else-if="dataDetail.status === 'processing'"
                    color="#3949AB"
                    outlined
                    class="text-capitalize"
                  >
                    {{ dataDetail.status }}
                  </v-chip>
                  <v-chip
                    v-else-if="dataDetail.status === 'canceled'"
                    color="#D81B60"
                    outlined
                    class="text-capitalize"
                  >
                    {{ dataDetail.status }}
                  </v-chip>
                  <v-chip
                    v-else-if="dataDetail.status === 'completed'"
                    color="#0277BD"
                    outlined
                    class="text-capitalize"
                  >
                    {{ dataDetail.status }}
                  </v-chip>
                  <v-chip
                    v-else
                    :color="dataDetail.status == 'approved' ? 'success' : '#ADADAD'"
                    outlined
                    class="text-capitalize"
                  >
                    {{ dataDetail.status }}
                  </v-chip>
                </v-row>
              </v-list-item>
            </v-card-actions>
            <v-simple-table height="300px">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td style="width:30%;">DATE</td>
                    <td>{{ dataDetail.approved_at || "-" }}</td>
                  </tr>
                  <tr>
                    <td>BANK ACCOUNT NO.</td>
                    <td>{{ dataDetail.receipient_account_number }}</td>
                  </tr>
                  <tr>
                    <td>BANK CODE</td>
                    <td class="text-uppercase">{{ dataDetail.receipient_bank_code }}</td>
                  </tr>
                  <tr>
                    <td>ACCOUNT NAME</td>
                    <td class="text-capitalize">{{ dataDetail.receipient_account_name }}</td>
                  </tr>
                  <tr>
                    <td>REMARKS</td>
                    <td class="text-capitalize">{{ dataDetail.remark }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>

          <v-snackbar
            v-model="isError"
          >
            {{ showMessage }}
            <template v-slot:action="{ attrs }">
              <v-btn
                color="pink"
                text
                v-bind="attrs"
                @click="isError = false"
              >
                Close
              </v-btn>
            </template>
          </v-snackbar>
        </div>        
      </div>
    </v-card-text>   

    <v-dialog
      v-model="dialog"
      width="700"
    >
      <v-card class="pa-2">
        <p class="fs-18 text-black ma-2">
          Below are the batch disbursement details you are about to approve
        </p>
        <v-divider></v-divider>

        <v-card-text class="my-3">
          <div class="row mb-3">
            <div class="col-md-3 px-0" style="border-right: 1px solid #eee;border-bottom: 1px solid #eee;">
              <v-card rounded="lg" class="transparent px-0">
                <v-card-text class="py-5">
                  <p class="text-semu fs-12">STATUS</p>
                  <p class="fs-16 text-black font-weight-medium text-uppercase">{{ dataDetail.status }}</p>
                </v-card-text>
              </v-card>
            </div>
            <div class="col-md-3 px-0" style="border-right: 1px solid #eee;border-bottom: 1px solid #eee;">
              <v-card rounded="lg" class="transparent px-0">
                <v-card-text class="py-5">
                  <p class="text-semu fs-12">TOTAL AMOUNT</p>
                  <p class="fs-16 text-black font-weight-medium">Rp {{ formatPrice(dataDetail.amount) }}</p>
                </v-card-text>
              </v-card>
            </div>
            <div class="col-md-6 px-0" style="border-bottom: 1px solid #eee;">
              <v-card rounded="lg" class="transparent px-0">
                <v-card-text class="py-5">
                  <p class="text-semu fs-12">INPUT BY</p>
                  <p class="fs-16 text-black font-weight-medium"><span class="text-capitalize">{{ dataDetail.creator_user_name }}</span> on {{ dataDetail.validated_at }}</p>
                </v-card-text>
              </v-card>
            </div>
          </div>
          <p class="mb-0"><v-icon color="#FFC234">ri-error-warning-fill</v-icon> Phasellus accumsan imperdiet tempor. Cras tincidunt, arcu nec eleifend porttitor, orci est vehicula velit, scelerisque fringilla ligula mi in urna. Nulla ut odio eu mi congue molestie. Maecenas tortor neque.</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"            
            @click="dialog = false"
            class="text-center px-5"
            outlined
            large
          >
            Cancel
          </v-btn>
          <!-- @click="dialog = false;pin=true" -->
          <v-btn
            color="primary"            
            class="text-center px-5"
            large
            @click="handleSubmit()"
            :loading="isLoading"
          >
            Approve
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> 
  </v-card>
</template>

<script>
import axios from "axios";
import { formatPrice, formatDate } from "@/lib/formatDate";

export default {
  data: () => ({
    items: [
      {
        text: 'E-Transfer',
        disabled: false,
        href: '#',
      },
      {
        text: 'Send Money',
        disabled: false,
        href: '#',
      },
      {
        text: 'Single Disbursement',
        disabled: false,
        href: '/disbursement?tab=need-approval',
      },
      {
        text: 'Need Approval Detail',
        disabled: true,
        href: '#',
      },
    ],
    dialog:false,
    dataDetail: {},
    showMessage: '',
    isError: false,
    isLoading: false,
    serverParams: {
      disbursement_id: ""
      // id: "",
      // type: ""
    }
  }),
  mounted() {
    this.getListDisbursmentDetail()
  },
  computed: {
    dateRangeText () {
      return this.dates.join(' ~ ')
    },
    idParam: {
      get() {
        return this.$route.params.id;
      }
    }
  },
  methods: {
    getListDisbursmentDetail() {
      return new Promise((resolve, reject) => {
          axios
          .get(`etransfer/disbursement/detail/${this.idParam}` )
          .then(response => {
            this.dataDetail = response.data.result.data;
            this.serverParams.disbursement_id = this.dataDetail.id;
            // if(this.dataDetail.type == "bulk") {
            //   this.serverParams.type = this.dataDetail.type;
            // } else {
            //   this.serverParams.type = "";
            // }
            // this.serverParams.type = this.dataDetail.type;
            // console.log('object', this.dataDetail);
            resolve(response);
          })
          .catch(error => {
              reject(error);
          });
      });
    },

    handleSubmit() {
      // console.log('object', this.serverParams);
      setTimeout(() => {
        this.isLoading = true;
        this.$store.dispatch("validateNeedApproval2", this.serverParams)
        .then((response) => {
          this.isError = true;
          this.showMessage = response.data.message;
          this.isLoading = false;
          setTimeout( () => {
            this.$router.push({path: '/disbursement', query: { tab: 'approved' }})
          }, 1000);
        })
        .catch((error) => {
          this.isLoading = false;
          this.isError = true;
          this.showMessage = error.response.data.message;
        });
      }, 50);
    },

    formatDate(value) {
      return formatDate(value);
    },

    formatPrice(value) {
      return formatPrice(value);
    },
  },
};
</script>

<style>
</style>